export default {
  tableColumns: [
    {
      label: '250',
      value: 250
    },
    {
      label: '500',
      value: 500
    },
    {
      label: '1000',
      value: 1000
    },
    {
      label: '1500',
      value: 1500
    },
    {
      label: '2000',
      value: 2000
    },
    {
      label: '3000',
      value: 3000
    },
    {
      label: '4000',
      value: 4000
    },
    {
      label: '6000',
      value: 6000
    },
    {
      label: '8000',
      value: 8000
    }
  ],
  metrics: [
    {
      label: 'clinical.people.anamnesis.right_ear_areal_hearing_loss',
      ear: 'right',
      field: 'right_ear_areal_hearing_loss',
      frequencies: [250, 500, 1000, 1500, 2000, 3000, 4000, 6000, 8000],
      masking_field: 'right_ear_areal_masking'
    },
    {
      label: 'clinical.people.anamnesis.left_ear_areal_hearing_loss',
      ear: 'left',
      field: 'left_ear_areal_hearing_loss',
      frequencies: [250, 500, 1000, 1500, 2000, 3000, 4000, 6000, 8000],
      masking_field: 'left_ear_areal_masking'
    },
    {
      label: 'clinical.people.anamnesis.right_ear_bone_hearing_loss',
      ear: 'right',
      field: 'right_ear_bone_hearing_loss',
      frequencies: [500, 1000, 1500, 2000, 3000, 4000],
      masking_field: 'right_ear_bone_masking'
    },
    {
      label: 'clinical.people.anamnesis.left_ear_bone_hearing_loss',
      ear: 'left',
      field: 'left_ear_bone_hearing_loss',
      frequencies: [500, 1000, 1500, 2000, 3000, 4000],
      masking_field: 'left_ear_bone_masking'
    },
    {
      label: 'clinical.people.anamnesis.right_ear_uncomfortable_loudness_level',
      ear: 'right',
      field: 'right_ear_uncomfortable_loudness_level',
      frequencies: [500, 1000, 2000, 4000],
      masking_field: null
    },
    {
      label: 'clinical.people.anamnesis.left_ear_uncomfortable_loudness_level',
      ear: 'left',
      field: 'left_ear_uncomfortable_loudness_level',
      frequencies: [500, 1000, 2000, 4000],
      masking_field: null
    }
  ]
}
